"use client";

import { useEffect } from "react";

export default function F5Refresh() {
	useEffect(() => {
		const handler = async (e: KeyboardEvent) => {
			const isF5 = e.key === "F5";
			const isReloadCombo =
				(e.ctrlKey || e.metaKey) && (e.key === "r" || e.key === "R");
			if (!isF5 && !isReloadCombo) return;

			e.preventDefault();

			try {
				if ("serviceWorker" in navigator) {
					const reg = await navigator.serviceWorker.getRegistration();
					if (reg) await reg.update();
				}
			} catch {
				// ignore
			}

			window.location.reload();
		};

		window.addEventListener("keydown", handler);
		return () => window.removeEventListener("keydown", handler);
	}, []);

	return null;
}
